<template>
  <div class="product-wrapper">
    <div class="product">
      <span v-if="product.hasCombiDeals" class="has-combi-deals"/>
      <span class="modality">{{ modalityDescription }}</span>
      <h2>{{ product.title }}</h2>
      <ul class="tariff-selector">
        <product-configuration v-for="configuration in configurationsToShow"
                               :key="configuration.id"
                               :configuration="configuration"
                               @click.native="revealProductDetail(configuration.customerGroup, configuration.term)"/>
      </ul>
      <a href="#"
         data-reveal-id="productDetail"
         class="button alt"
         @click.prevent="revealProductDetail(customerGroupToShow)"
         v-html="$t('productOverview.orderButtonText', {productTitle: product.title})"/>
    </div>
  </div>
</template>

<script>
import ProductConfiguration from './ProductConfiguration'
import changeCase from 'change-case/change-case'
import { mapGetters } from 'vuex'

export default {
  components: {
    ProductConfiguration
  },
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters('selection', [
      'configurationsByProductSortedByTermDuration',
      'customerGroupsByProduct',
      'customerGroupToShowForProduct'
    ]
    ),
    configurations: function () {
      return this.configurationsByProductSortedByTermDuration(this.product)
    },
    configurationsToShow: function () {
      return this.configurations.filter(configuration => this.customerGroupToShow && configuration.customerGroup.id === this.customerGroupToShow.id)
    },
    customerGroups: function () {
      const customerGroups = this.customerGroupsByProduct(this.product)

      return customerGroups.sort((a, b) => a.order - b.order)
    },
    customerGroupToShow: function () {
      return this.customerGroupToShowForProduct(this.product)
    },
    modalityDescription: function () {
      return this.product.modalities
        .map((modality) => changeCase.lowerCase(modality.title))
        .sort((a, b) => a.localeCompare(b))
        .join(', ')
    }
  },
  methods: {
    revealProductDetail: function (customerGroup, term = '') {
      // the customerGroup received here can be incomplete (containing only an id), so find the complete customerGroup first:
      customerGroup = this.customerGroups.find(completeCustomerGroup => completeCustomerGroup.id === customerGroup.id)
      if (customerGroup !== null) {
        this.$emit('revealProductDetail', this.product, customerGroup, term)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product-overview/Product.vue